import { useEffect, useState } from 'react';
import { useChangeColorMutation } from '../../api/AuftragAPI';
import AuftragTerminierenComponent from '../../component/AuftragTerminierenComponent/AuftragTerminierenComponent';
import CalendarComponent from '../../component/CalendarComponent/CalendarComponent';
import MapShowLocationsComponent, { IMapShowLocationsComponent } from '../../component/MapShowLocations/MapShowLocationsComponent';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAuftrag } from '../../types/Types';
import Styles from './auftragterminieren.module.scss';
import DialogCalendarComponent from '../../component/DialogCalendarComponent/DialogCalendarComponent';

export type IAuftragsdaten = {
  stunde: string,
  minute: string,
  wiedervorlagetage: string,
  terminierungFertig: boolean,
  termindatum: string,
}

/**
 * @author noone
 */
export type IAuftragTerminierenProps = {
  liste: IAuftrag[];
  statusChanged: () => void;
}
export default function AuftragTerminieren(props: IAuftragTerminierenProps) {

  const [showDiv1, setShowDiv1] = useState<boolean>(true);
  const [showDiv2, setShowDiv2] = useState<boolean>(true);
  const [showCalendar , setShowCalendar] = useState<boolean>(false);

  const [auftragLocations, setAuftragLocations] = useState<IMapShowLocationsComponent[]>([]);
  const [map1, setMap1] = useState<Map<string, number>>(new Map());
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [localListe, setLocalListe] = useState<IAuftrag[]>([]);

  const [changeColorAPI] = useChangeColorMutation();

  const changeColor = (auftraguid: string, color: string) => {
    setAuftragLocations((prevLocations) =>
      prevLocations.map((auftrag) =>
        auftrag.uid === auftraguid ? { ...auftrag, color } : auftrag
      )
    );

    // change color api
    changeColorAPI({ uid: auftraguid, color: (color.length === 7) ? color.substring(1) : color });

  }

  const statusChanged = () => {
    props.statusChanged();
  }

  const centerOnMap = (index: string) => {
    // Rufe die Callback auf der Map-Komponente auf
    if ((window as any).centerMapCallback) {

      // Die Methode centerMapCallback wird in der useEffect von MapShowLocationsComponent registriert
      (window as any).centerMapCallback(index);
    }
  }

  const suche = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value.toLowerCase();

    if (searchTerm === "") {
      setLocalListe(props.liste);
      return;
    }

    var liste1 = props.liste.filter(auftrag =>
      (auftrag.vorname_endkunde + " " + auftrag.name_endkunde).toLowerCase().includes(searchTerm) ||
      auftrag.stadt_lieferadresse.toLowerCase().includes(searchTerm) ||
      auftrag.art.toLowerCase().includes(searchTerm)
    );
    setLocalListe(liste1);
  }


  // Sortiere und erstelle Locations / uid->number Mapping, wenn props.liste sich ändert
  useEffect(() => {
    const source = props.liste ?? [];
    const sorted = [...source].sort((a, b) => {
      if (a.angepinnt && !b.angepinnt) return -1;
      if (!a.angepinnt && b.angepinnt) return 1;
      const ta = a.createDate ? (typeof a.createDate === 'string' ? new Date(a.createDate).getTime() : a.createDate.getTime()) : 0;
      const tb = b.createDate ? (typeof b.createDate === 'string' ? new Date(b.createDate).getTime() : b.createDate.getTime()) : 0;
      return ta - tb;
    });

    const uidMap = new Map<string, number>();
    sorted.forEach((auftrag, idx) => uidMap.set(auftrag.uid, idx + 1));
    setMap1(uidMap);

    const listeTmp: IMapShowLocationsComponent[] = sorted.map(it => ({
      uid: it.uid,
      numberOnMap: uidMap.get(it.uid)!,
      lat: it.lat,
      lng: it.lng,
      color: (it.colorAuftrag.length === 7) ? it.colorAuftrag : "#" + it.colorAuftrag
    }));

    setAuftragLocations(listeTmp);
    setLocalListe(sorted); // setze lokal die sortierte Liste => UI zeigt sortiert
    setIsLoaded(true);
  }, [props.liste]);

  useEffect(() => {
    const uidMap = new Map<string, number>();
    localListe.forEach((auftrag, idx) => uidMap.set(auftrag.uid, idx + 1));
    setMap1(uidMap);

    const listeTmp: IMapShowLocationsComponent[] = localListe.map(it => ({
      uid: it.uid,
      numberOnMap: uidMap.get(it.uid) ?? 0,
      lat: it.lat,
      lng: it.lng,
      color: it.colorAuftrag ? ((it.colorAuftrag.length === 7) ? it.colorAuftrag : "#" + it.colorAuftrag) : "#000000"
    }));
    setAuftragLocations(listeTmp);
  }, [localListe]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (

    <>

      <DialogCalendarComponent close={ () => setShowCalendar(false)} dialogVisible={showCalendar} />

      <div style={{display: 'flex', gap: '10px', padding: '10px', backgroundColor: '#f8f9fa' , position: 'sticky', top: 0, zIndex: 100, justifyContent: 'space-between' }}>
        <button
          className="btn btn-primary"
          onClick={() => setShowDiv1(!showDiv1)}
        >
          {showDiv1 ? '◀ Liste Ausblenden' : '▶ Liste Anzeigen'}
        </button>

        <button
          className="btn btn-primary"
          onClick={() => setShowCalendar(true)}
        >
          {'Kalendar Anzeigen'}
        </button>

        <button
          className="btn btn-primary"
          onClick={() => setShowDiv2(!showDiv2)}
        >
          {showDiv2 ? 'Karte Ausblenden ▶' : 'Calendar Anzeigen  ◀'}
        </button>
      </div>

      <div className={`${Styles.grid1} ${showDiv1 ? Styles.showDiv1 : Styles.hideDiv1} ${showDiv2 ? Styles.showDiv2 : Styles.hideDiv2}`}>

        <div id="div1" style={{
          overflowY: 'auto',
          height: '100%',
          display: showDiv1 ? 'block' : 'none',
        }}>

          <p>
            <input type="text" className='form-control' placeholder='Suche' onChange={suche} />
          </p>

          {localListe.map((auftrag, index) =>
            <AuftragTerminierenComponent
              key={auftrag.uid}
              changeColor={changeColor}
              statusChanged={statusChanged}
              centerOnMap={centerOnMap}
              numberOnMap={map1.get(auftrag.uid) ?? index + 1}
              propsAuftrag={auftrag}
            />
          )}  

          <ScrollToTopBadge />

        </div>

        <div id="div2" style={{
          position: 'sticky',
          top: 0,
          height: '100vh',
          display: showDiv2 ? 'block' : 'none',
        }}>
          {isLoaded &&
            <>
              <MapShowLocationsComponent locations={auftragLocations} centerOnMap={centerOnMap} />
              {/*<CalendarComponent />*/}
            </>}
        </div>
      </div >
    </>
  );

}
